import { render } from "./AdmMenu.vue?vue&type=template&id=7637864a&scoped=true"
import script from "./AdmMenu.vue?vue&type=script&lang=js"
export * from "./AdmMenu.vue?vue&type=script&lang=js"

import "./AdmMenu.vue?vue&type=style&index=0&id=7637864a&scoped=true&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7637864a"]])

export default __exports__